import { Quote } from "lucide-react";

const testimonials = [
  {
    quote:
      "Avevo un bilocale in zona Porta Romana in affitto breve: tanto lavoro, poca resa reale. Francesca ha ribaltato l'impostazione passando al transitorio. Oggi incasso di più, con zero pensieri.",
    name: "Marco B.",
    role: "Proprietario · Milano",
  },
  {
    quote:
      "Professionalità e chiarezza. Francesca mi ha mostrato i numeri veri, non quelli di facciata. Ho scelto il 4+4 per tranquillità e non potrei essere più soddisfatta.",
    name: "Elena R.",
    role: "Proprietaria · Milano",
  },
  {
    quote:
      "La sua conoscenza del mercato milanese è rara. Ha trovato l'inquilino giusto per il transitorio in meno di tre settimane, con contratto blindato.",
    name: "Andrea F.",
    role: "Investitore · Monza",
  },
];

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="relative bg-white border-t border-brand-line py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="max-w-2xl">
          <p className="divider-ornament" data-testid="testimonials-eyebrow">Testimonianze</p>
          <h2
            data-testid="testimonials-headline"
            className="font-display text-4xl sm:text-5xl lg:text-[3.5rem] leading-[1.05] font-bold text-brand-ink mt-8"
          >
            Proprietari che<span className="italic font-normal"> hanno fatto i conti giusti</span>.
          </h2>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="relative bg-brand-bg border border-brand-line p-8 sm:p-10 rounded-sm flex flex-col"
            >
              <Quote
                size={34}
                className="text-brand-beigeDark"
                strokeWidth={1.2}
              />
              <blockquote className="mt-6 text-base leading-relaxed text-brand-text">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-brand-line">
                <div className="font-display text-lg font-semibold text-brand-ink">{t.name}</div>
                <div className="mt-1 text-xs uppercase tracking-[0.18em] text-brand-muted">
                  {t.role}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
